import React, { useEffect } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import {
  countryCordinatesById,
} from "@hooks/useGeneralParams";
import CKEditorText from "@components/CKEditorText/CKEditorText";
import { MapDraw } from "@utils/map-draw";
import {
  MapContainer,
  EditorDescriptionWrapper,
  EditorDescriptionTitle,
  ZoneContainer,
} from "./AddEditZone.styled";

import "./ckeditor.css";

const AddEditZone = (props) => {
  const { t, data, error, setCatchmentZone, setTechnicalInfo, countryId } =
    props;

  const defaultCoordinates = countryCordinatesById(countryId);

  let coordinates = [];
  if (data?.catchmentValue !== "") {
    // eslint-disable-next-line dot-notation
    coordinates = JSON.parse(data.catchmentValue)["features"][0].geometry
      .coordinates;
  }
  useEffect(() => {
    MapDraw(
      defaultCoordinates.latitude,
      defaultCoordinates.longitude,
      coordinates,
      data.id,
      setCatchmentZone
    );
  }, []);

  return (
    <>
      <ZoneContainer error={error !== ""}>
        <MapContainer id="map" />
      </ZoneContainer>
      <EditorDescriptionWrapper>
        <EditorDescriptionTitle>
          {t("CATCHMENT_AREA_TECH_INFO")}
        </EditorDescriptionTitle>
      </EditorDescriptionWrapper>
      <div>
        <CKEditorText
          descriptionData={data?.catchmentTechnicalInfo}
          setDescriptionData={setTechnicalInfo}
        />
      </div>
    </>
  );
};

AddEditZone.propTypes = {
  t: PropTypes.func.isRequired,
  coordinates: PropTypes.array,
};

AddEditZone.defaultProps = {
  coordinates: [],
};

export default withTranslation()(AddEditZone);
